<script>
    import { createEventDispatcher, onMount } from 'svelte';
    export let adTime = 1500
    export let animateSlide = false;
    $: if(!animateSlide){
        last_time = window.performance.now();
        elapsed = adTime;
    }
    function wait(milliseconds) {
  		return new Promise(resolve => setTimeout(resolve, milliseconds));
	}
    let elapsed = adTime;
	let duration = 0;

	let last_time = window.performance.now();
	let frame;

	(function update() {
		frame = requestAnimationFrame(update);
        if(!animateSlide && elapsed != 0){
            const time = window.performance.now();
            elapsed -= Math.min(time - last_time, elapsed);

            last_time = time;
        }

	})();

    let mouseX = 0;
    let mouseDisplacementX = 0;
    let elem = null;
    const dispatch = createEventDispatcher();
    function MoveItemMouse(e){
        e = e || window.event;
        e.preventDefault();
        mouseDisplacementX += (e.clientX - mouseX);
        if(mouseDisplacementX >= 200){
            dispatch('sway', {
		        text: 'r'
	        });
        }
        else if(mouseDisplacementX <= -200){
            dispatch('sway', {
		        text: 'l'
	        });
        }
        else{
            dispatch('sway', {
		        text: 'off'
	        });
        }
        mouseX = e.clientX;
    }
    function MoveItemTouch(e){
        e = e || window.event;
        var touch = e.touches[0];
        mouseDisplacementX += (touch.pageX - mouseX);
        if(mouseDisplacementX >= 50){
            dispatch('sway', {
		        text: 'r'
	        });
        }
        else if(mouseDisplacementX <= -50){
            dispatch('sway', {
		        text: 'l'
	        });
        }
        else{
            dispatch('sway', {
		        text: 'off'
	        });
        }
        mouseX = touch.pageX;
    }
    function GetMousePosition(e){
        elem = document.getElementById("draggable");
        e = e || window.event;
        mouseX = e.clientX;
        document.onmousemove = MoveItemMouse;
        document.onmouseup = closeDragElement;
    }
    function closeDragElement() {
        document.onmouseup = null;
        document.onmousemove = null;
        document.ontouchmove = null;
        document.ontouchend = null;
        if(mouseDisplacementX >= 200){
            dispatch('sway', {
		        text: 'rend'
	        });
        }
        else if(mouseDisplacementX <= -200){
            dispatch('sway', {
		        text: 'lend'
	        });
        }
        else{
            dispatch('sway', {
		        text: 'off'
	        });
        }
        mouseDisplacementX = 0;
        
    }
    function GetTouchPosition(e){
        elem = document.getElementById("draggable");
        e = e || window.event;
        var touch = e.touches[0];
        mouseX = touch.pageX
        document.ontouchmove = MoveItemTouch;
        document.ontouchend = closeDragElement;
    }
</script>

<style>
    #draggable{
        display: flex;
		justify-content: center;
		align-content: center;
		align-items: center;
    }
    .base{
        background-color: #1B1B1B;
        color: whitesmoke;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        border-radius: 5em;
        min-height: 80vh;
        margin-top: 5vh;
        margin-bottom: 10vh;
        padding-left: 5vw;
        padding-right: 5vw;
        min-width: 30vw;
        width: 50vw;
    }

    @media only screen and (max-width: 900px) {
        .base{
            border-radius: 5em;
            padding-left: 5vw;
            padding-right: 5vw;
            margin-top: 5vh;
            margin-bottom: 10vh;
            min-height: 80vh;
            height: 80vh;
        }
        
    }
    @media only screen and (max-width: 700px) {
        .base{
            border-radius: 5em;
            margin-top: 5vh;
            margin-bottom: 10vh;
            padding-left: 5vw;
            padding-right: 5vw;
            min-height: 80vh;
            max-width: 70vw;
            height: 80vh;
        }
    }
    @media only screen and (max-width: 400px) {
        .base{
            border-radius: 2em;
            margin-top: 5vh;
            margin-bottom: 10vh;
            padding-left: 10vw;
            padding-right: 10vw;
            min-height: 80vh;
            height: 80vh;
        }
    }
</style>

<body on:load{GetElem()}>
    <div on:mousedown={GetMousePosition} on:touchstart={GetTouchPosition} id="draggable">
        <div class="base">
            <h1>Thank you for Supporting Toothpicky!</h1>
            <script type="text/javascript">
                atOptions = {
                    'key' : 'b7ae04738ea128303b6684a7ffca1c7c',
                    'format' : 'iframe',
                    'height' : 250,
                    'width' : 300,
                    'params' : {}
                };
            </script>
            <script type="text/javascript" src="//www.topcreativeformat.com/b7ae04738ea128303b6684a7ffca1c7c/invoke.js"></script>
            <h2>Explore the Ad to further Support!</h2>
            <h2>{"Continue in " + ((elapsed / 1000).toFixed(1)).toString() + " seconds"}</h2>
        </div>
    </div>
</body>